module.exports = __webpack_public_path__ + "img/affinity_off.3f1fee05.svg";